export default __webpack_public_path__ + "static/media/referServicePro.a5c93df5.svg";